import { ConfirmationModalProps } from "../../../utils/interfaces";

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    show,
    onClose,
    onConfirm,
    title,
    body,
    maxHeight="20vh",
    maxWidth="30vw",
    closeText="CANCEL",
    color="#8D07A4"
}) => {
    return (
        <>
            {show && (
                <div
                    className="modal-overlay"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        zIndex: 999,
                    }}
                ></div>
            )}

            <div
                className="modal card fadeIn"
                style={{
                    display: show ? "block" : "none",
                    position: "absolute",
                    maxWidth: maxWidth,
                    // minHeight: 'fit-content',
                    maxHeight: maxHeight,
                    top: "50%",
                    left: "47.9%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1000,
                    border: "1px solid #dee2e6",
                    borderRadius: "1.875rem",
                }}
            >
                <div className="modal-header mainScreen" style={{
                    borderBottomColor: '#5376F0'
                }}>
                    <h5 className="modal-title" style={{
                        color: '#26397E',
                        fontSize: '1.625rem',
                        fontWeight: 'bold'
                    }}>{title}</h5>
                </div>
                <div className="modal-body pt-5 mainScreen pb-0"  
                    style={{
                        // backgroundColor: onConfirm ? 'inherit' : '#ebe6e3', 
                        // maxHeight: '70% !important',
                        textAlign: 'center',
                        color: color,
                        fontWeight: 'bold',
                        fontSize: '1.625rem',
                        minWidth: '100%',
                    }}>
                        <div style={{
                            maxHeight: '70% !important',
                            minWidth: '100%',
                            overflowY: 'auto',
                            // padding: '1rem'
                        }}>
                            {body}
                        </div>
                </div>
                <div className="modal-footer d-flex flex-row align-items-center justify-content-center gap-2 px-4 pb-3 mainScreen" style={{
                    border: 'none',
                    paddingBottom: '1.5rem'
                }}>
                    <button 
                        className="btn btn-rounded btn-confirmation clr-black btn-confirmation-cancel"
                        onClick={onClose} 
                        style={{width: '32%', transition: 'all 0.3s ease'}}
                        onMouseEnter={(e) => {
                            const target = e.target as HTMLButtonElement;
                            target.style.backgroundColor = '#5376F0 !important';
                            target.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                            const target = e.target as HTMLButtonElement;
                            target.style.backgroundColor = '#ABCAFF !important';
                            target.style.transform = 'translateY(0)';
                        }}
                    >
                       {closeText}
                    </button>
                    {onConfirm && (
                        <button 
                            className="btn btn-rounded-blue btn-confirmation" 
                            onClick={onConfirm} 
                            style={{width: '32%', transition: 'all 0.3s ease'}}
                            onMouseEnter={(e) => {
                                const target = e.target as HTMLButtonElement;
                                target.style.backgroundColor = '#5376F0 !important';
                                target.style.transform = 'translateY(-2px)';
                            }}
                            onMouseLeave={(e) => {
                                const target = e.target as HTMLButtonElement;
                                target.style.backgroundColor = '#ABCAFF !important';
                                target.style.transform = 'translateY(0)';
                            }}
                        >
                            CONFIRM
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};
